$(document).ready(function() {
  
  //--------quick add button in best sellers section js starts----------//
  $(".cstm_card_wrapper.product-card-wrapper").hover(function () {
    $(this).toggleClass("result_hover");
    $(".cstm_card_wrapper.product-card-wrapper").not(this).removeClass('result_hover');
  });
  //--------quick add button in best sellers section js ends----------//

  //--------footer accordian for mobile starts------------------//
  if($(window).width() < 990) {
    $(".cstm_footer_block_content").hide();
    $(".cstm_footer_block_heading").click(function(){
      $(".cstm_footer_block_heading").not(this).parents(".cstm_block_menu").find(".cstm_footer_block_content").slideUp();
      $(".cstm_footer_block_heading").not(this).parents(".cstm_block_menu").removeClass("arrow-animate");
      $(this).parents(".cstm_block_menu").find(".cstm_footer_block_content").slideToggle();  
      $(this).parents(".cstm_block_menu").toggleClass("arrow-animate");       
    });
  }  
  //--------footer accordian for mobile ends------------------//

  //--------custom text slider(header) js starts--------//
  $('.cstm_header_wrapper .cstm_text_slider_inner_div').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    autoplay: true,
    autospeed: 5000
  });
  //--------custom text slider(header) js ends--------//

  //------product page description read more less---------------//
  $('.product__info-wrapper .read_more_prod_desc').click(function(){
    var prod_desc = $('.product__info-wrapper .product__description');
    var prod_desc_btn = $('.product__info-wrapper .read_more_prod_desc .read_more_prod_btn');
    prod_desc.toggleClass('prod_read_more_active');
    if(prod_desc.hasClass('prod_read_more_active')) {
      prod_desc_btn.text('- less');         
    } else {
      prod_desc_btn.text('+ more');
    }
  });

  //--------custom multicolumn 1 js starts for science page--------//
  $('.template-page .cstm_science_ingredients.multicolumn-1 .multicolumn-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    nextArrow: '<button type="button" class="slick-next"><svg width="28" height="24" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5995 8.83774L11.029 16.4082C10.9715 16.4657 10.8395 16.427 10.7342 16.3217L9.97144 15.559C9.86613 15.4537 9.8274 15.3216 9.88494 15.2641L17.4554 7.69366C17.5129 7.63612 17.6449 7.67485 17.7503 7.78016L18.513 8.54288C18.6183 8.64819 18.657 8.7802 18.5995 8.83774Z" fill="#222222"/><path d="M17.4548 9.77115L9.87863 2.195C9.82105 2.13742 9.85974 2.00537 9.96505 1.90006L10.7278 1.13734C10.8331 1.03203 10.9651 0.993334 11.0227 1.05091L18.5989 8.62707C18.6564 8.68465 18.6178 8.81669 18.5124 8.922L17.7497 9.68473C17.6444 9.79004 17.5124 9.82873 17.4548 9.77115Z" fill="#222222"/></svg></button>',
    prevArrow: '<button type="button" class="slick-prev"><svg width="28" height="24" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5995 8.83774L11.029 16.4082C10.9715 16.4657 10.8395 16.427 10.7342 16.3217L9.97144 15.559C9.86613 15.4537 9.8274 15.3216 9.88494 15.2641L17.4554 7.69366C17.5129 7.63612 17.6449 7.67485 17.7503 7.78016L18.513 8.54288C18.6183 8.64819 18.657 8.7802 18.5995 8.83774Z" fill="#222222"/><path d="M17.4548 9.77115L9.87863 2.195C9.82105 2.13742 9.85974 2.00537 9.96505 1.90006L10.7278 1.13734C10.8331 1.03203 10.9651 0.993334 11.0227 1.05091L18.5989 8.62707C18.6564 8.68465 18.6178 8.81669 18.5124 8.922L17.7497 9.68473C17.6444 9.79004 17.5124 9.82873 17.4548 9.77115Z" fill="#222222"/></svg></button>',
    responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
      }
    }
   ]
  });
  //--------custom multicolumn 1 js ends for science page--------//

  //--------custom multicolumn 2 js starts for science page--------//
  $('.template-page .cstm_science_ingredients.multicolumn-2 .multicolumn-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    nextArrow: '<button type="button" class="slick-next"><svg width="28" height="24" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5995 8.83774L11.029 16.4082C10.9715 16.4657 10.8395 16.427 10.7342 16.3217L9.97144 15.559C9.86613 15.4537 9.8274 15.3216 9.88494 15.2641L17.4554 7.69366C17.5129 7.63612 17.6449 7.67485 17.7503 7.78016L18.513 8.54288C18.6183 8.64819 18.657 8.7802 18.5995 8.83774Z" fill="#222222"/><path d="M17.4548 9.77115L9.87863 2.195C9.82105 2.13742 9.85974 2.00537 9.96505 1.90006L10.7278 1.13734C10.8331 1.03203 10.9651 0.993334 11.0227 1.05091L18.5989 8.62707C18.6564 8.68465 18.6178 8.81669 18.5124 8.922L17.7497 9.68473C17.6444 9.79004 17.5124 9.82873 17.4548 9.77115Z" fill="#222222"/></svg></button>',
    prevArrow: '<button type="button" class="slick-prev"><svg width="28" height="24" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.5995 8.83774L11.029 16.4082C10.9715 16.4657 10.8395 16.427 10.7342 16.3217L9.97144 15.559C9.86613 15.4537 9.8274 15.3216 9.88494 15.2641L17.4554 7.69366C17.5129 7.63612 17.6449 7.67485 17.7503 7.78016L18.513 8.54288C18.6183 8.64819 18.657 8.7802 18.5995 8.83774Z" fill="#222222"/><path d="M17.4548 9.77115L9.87863 2.195C9.82105 2.13742 9.85974 2.00537 9.96505 1.90006L10.7278 1.13734C10.8331 1.03203 10.9651 0.993334 11.0227 1.05091L18.5989 8.62707C18.6564 8.68465 18.6178 8.81669 18.5124 8.922L17.7497 9.68473C17.6444 9.79004 17.5124 9.82873 17.4548 9.77115Z" fill="#222222"/></svg></button>',
    responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '50px',
      }
    }
   ]
  });
  //--------custom multicolumn 2 js ends for science page--------//
    
});
